module.exports = __webpack_public_path__ + "img/noCoupou.d11b9e1d.png";